import { DataItemType, FormControlType } from "@cloudpivot/form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "./components/pc-upload.vue";
import mobile from "./components/mobile-upload.vue";
export const info = {
    title: "图片",
    type: "picture-card",
    icon: "h-icon-all-picture-o",
    dataItemType: DataItemType.Attachment,
    formControllerType: FormControlType.Image,
    group: "基础控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
